export default __webpack_public_path__ + "static/media/banner.758ac9f0.mp4";